export const APP_VERSION = '1.28.0';
